export default __webpack_public_path__ + "static/media/Beard_9_C1.f8df054a.svg";